import Vue from 'vue';

export const SET_FEEDBACK_MSG = 'SET_FEEDBACK_MSG';

const storageModule = {
  namespaced: true,
  state: {
    lastPlp: null,
    bikeTechSKU: null,
    feedbackMsg: '',
    purchaseMode: localStorage.purchaseMode ? localStorage.purchaseMode : false,
    usersTouchedAllocatedItems: [],
  },
  getters: {
    purchaseMode(state) {
      return state.purchaseMode;
    },
    hasUserTouchedAllocatedItems(state) {
      return state.usersTouchedAllocatedItems.some(({email, b2bUnit}) => email === ACC.currentUserEmail && b2bUnit === ACC.currentB2BUnit);
    }
  },
  mutations: {
    setBikeTechSKU(state, sku) {
      Vue.set(state, 'bikeTechSKU', sku);
    },
    setLastPlp(state, value) {
      Vue.set(state, 'lastPlp', value);
    },
    setPurchaseMode(state, value) {
      Vue.set(state, 'purchaseMode', value);
    },
    [SET_FEEDBACK_MSG](state, message) {
      state.feedbackMsg = message;
    },
    addUserTouchedAllocatedItems(state) {
      state.usersTouchedAllocatedItems.push({email: ACC.currentUserEmail, b2bUnit: ACC.currentB2BUnit});
    },
    removeUserTouchedAllocatedItems(state) {
      state.usersTouchedAllocatedItems = state.usersTouchedAllocatedItems.filter(({email, b2bUnit}) => !(email === ACC.currentUserEmail && b2bUnit === ACC.currentB2BUnit));
    }
  },
  actions: {
    setFeedbackMsg({commit}, message) {
      commit(SET_FEEDBACK_MSG, message);
    },
    togglePurchaseMode({commit, state}) {
      let value = !state.purchaseMode;
      commit('setPurchaseMode', value);
    },
  },
};

export default storageModule;
